import Vue from 'vue';
import Notifications from 'vue-notification';

/**
 * In action.js
 * Vue.notify({
 *   group: 'notification',
 *   title: 'Important message',
 *   text: 'Care plan create successfully',
 *   type: 'success'
 * });
 *
 * In *.Vue file
 * this.appNotification({
 *   title: 'Important message',
 *   text: 'Hello user! This is a notification!',
 *   type: 'error'
 * });
 * * */
Vue.use(Notifications);
